export class Item {
  constructor(
    id,
    name,
    price,
    quantity,
    type,
    seriesName,
    setName,
    subtext,
    desc,
    conditionQuantities = null,
    pokemonType,
    setId,
    page,
    canBuy,
    lastUpdated = null
  ) {
    this.id = id;
    this.name = name;
    this.price = price;
    this.quantity = quantity;
    this.type = type;
    this.seriesName = seriesName;
    this.setName = setName;
    this.subtext = subtext;
    this.desc = desc;
    this.conditionQuantities = conditionQuantities;
    this.pokemonType = pokemonType.toLowerCase();
    this.setId = setId;
    this.page = page;
    this.canBuy = canBuy;
    this.lastUpdated = lastUpdated;
  }
}

export class CartItem {
  constructor (
    productId,
    condition,
    variant,
    count,
    discountType = null,
    appliedPrice = null,
    type
  ) {
    this.productId = productId;
    this.condition = condition;
    this.variant = variant;
    this.count = count;
    this.discountType = discountType;
    this.appliedPrice = appliedPrice;
    this.type = type;
  }
}

export class WishItem {
  constructor(obj = {}) {
    this.id = obj.id ?? null;

    // FK references
    this.cardId = obj.card_id ?? obj.card ?? null;
    this.variantId = obj.variant_id ?? null;
    this.conditionId = obj.condition_id ?? null;

    // Optional display helpers (only if serializer provides them)
    this.variantName = obj.variant_name ?? "";
    this.conditionName = obj.condition_name ?? "";

    // Wishlist metadata
    this.quantity = obj.quantity ?? 1;
    this.owned = obj.owned ?? false;
    this.createdAt = obj.created_at ?? null;
  }
}
